<template>
  <div>
    <!-- INFORMACIÓN DE OFERTA ACADÉMICA -->
    <informacionOferta
      :set-loader="loader"
      :detalle="detalle"
      :error="error"
    />

    <!-- TABS DE DETALLE DE OFERTA ACADÉMICA -->
    <informacionOfertaTabs
      :set-loader="loader"
      :detalle="detalle"
      :error="error"
    />
  </div>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api'
import { getData } from '@core/utils/http/general'
import { useToast } from 'vue-toastification/composition'
import { useRouter } from '@core/utils/utils'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import informacionOferta from './components/detalle-oferta/informacionOferta.vue'
import informacionOfertaTabs from './components/detalle-oferta/informacionOfertaTabs.vue'

export default {
  components: {
    informacionOferta,
    informacionOfertaTabs,
  },
  setup() {
    const { route } = useRouter()
    const toast = useToast()
    const detalle = ref({})
    const loader = ref(false)
    const error = ref(false)

    const loadData = () => {
      loader.value = true
      error.value = false

      getData({ action: 15 })
        .then(response => {
          loader.value = false
          if (response.status === 200 && response.data.status === 200) detalle.value = response.data.planes.find(item => item.id === parseInt(route.value.params.id, 10))
          else {
            detalle.value = {}
            error.value = true
          }
        })
        .catch(err => {
          detalle.value = {}
          loader.value = false
          error.value = true
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en solicitud [oferta académica]',
              text: err,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 8000 })
        })
    }

    onMounted(() => { loadData() })

    return {
      loader,
      detalle,
      error,
    }
  },
}
</script>
